import { createMuiTheme } from '@material-ui/core/styles'

export default createMuiTheme({
  palette: {
    background: {
      default: 'white'
    },
    text: {
      // primary: '',
      // secondary: 'rgba(255, 255, 255, 0.7)',
      // disabled: 'rgba(255, 255, 255, 0.5)'
    },
    action: {
      active: 'rgb(255, 255, 255)',
      hover: 'rgba(255, 255, 255, 0.7)',
      disabled: 'rgba(255, 255, 255, 0.5)'
    }
  },
  typography: {
    fontFamily: 'Quicksand',
    button: {
      borderBottom: '1px solid',
      fontFamily: 'Quicksand'
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  transitions: {
    create: () => 'none'
  },
  shape: {
    borderRadius: 0
  }
})
